import axiosInstance from "utils/axiosInterceptor";

export function list(data: any) {
    return axiosInstance({
        url: "/feedbacks/list?" + data,
        method: "get",
    });
}

export function getById(id: string) {
    return axiosInstance({
        url: "/feedbacks/getById?id=" + id,
        method: "get",
    });
}

export const apiMethod = {
    list,
    getById
};
